const ITEMS = [
  "What's New",
  "Inside the Trade",
  "Brands",
  "On the Banks",
  "The Hide Side",
  "Stillwater",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-ink-border bg-ink-surface py-6 md:py-8 overflow-hidden"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`px-6 md:px-10 font-serif text-2xl md:text-4xl whitespace-nowrap ${
                i % 2 === 0 ? "text-bone" : "italic text-faint"
              }`}
            >
              {item}
            </span>
            <span className="text-ember text-xl md:text-2xl">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
